
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-7---advanced-state"}}>{`Ex. 7 - Advanced State`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous allons refactorer notre composant `}<MDXTag name="inlineCode" components={components} parentName="p">{`useMovieSearch`}</MDXTag>{` avec `}<MDXTag name="inlineCode" components={components} parentName="p">{`useReducer`}</MDXTag>{` afin de le rendre plus clair et testable.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Utiliser `}<MDXTag name="inlineCode" components={components} parentName="li">{`useReducer`}</MDXTag>{` dans `}<MDXTag name="inlineCode" components={components} parentName="li">{`useMovieSearch`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Faire en sorte de retourner un tableau vide lorsque la query est une chaîne vide`}</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`Lorsque le champs de recherche est vide, j'obtiens une liste vide.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-7/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
<MDXTag name="h2" components={components} props={{"id":"aide"}}>{`Aide`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"counter-avec-usereducer"}}>{`Counter avec `}<MDXTag name="inlineCode" components={components} parentName="h3">{`useReducer`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`import React, { useReducer } from 'react'

function init(initialCount) {
  return { count: initialCount }
}

function reducer(state, action) {
  switch (action.type) {
    case 'increment':
      return { count: state.count + 1 }
    case 'decrement':
      return { count: state.count - 1 }
    case 'reset':
      return init(action.payload)
    default:
      throw new Error(\`Invalid action type \${action.type}\`)
  }
}

const initialCount = 0

function Counter() {
  const [state, dispatch] = useReducer(reducer, initialCount, init)
  return (
    <>
      Count: {state.count}
      <button
        onClick={() => dispatch({ type: 'reset', payload: initialCount })}
      >
        Reset
      </button>
      <button onClick={() => dispatch({ type: 'increment' })}>+</button>
      <button onClick={() => dispatch({ type: 'decrement' })}>-</button>
    </>
  )
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  